import React, { createContext, useContext, useState, useEffect } from "react";

const I18nContext = createContext();

const STRINGS = {
  en: {
    nav: {
      home: "Home", about: "About Us", export: "Export Commodities",
      import: "Import Products", services: "Trade Services",
      catalogue: "Catalogue Center", news: "News & Insights", contact: "Contact / RFQ",
      admin: "Admin",
    },
    common: {
      learnMore: "Learn More", viewAll: "View All", explore: "Explore",
      requestQuote: "Request Quote", contactUs: "Contact Us", readMore: "Read More",
      download: "Download", inquireNow: "Inquire Now", whatsappQuote: "WhatsApp Quote",
      requestAccess: "Request Access", submit: "Submit", cancel: "Cancel",
      loading: "Loading...", noResults: "No results found.",
      backToList: "Back to List", featured: "Featured",
    },
    hero: {
      eyebrow: "Global Trade • Commodity Trading • Trade Solutions",
      title: "Connecting Markets,",
      titleAccent: "Delivering Trust.",
      subtitle: "Premium import-export and commodity trading bridging Indonesia, Türkiye, Singapore and Southeast Asia with global markets.",
      cta1: "Explore Commodities", cta2: "Request a Quote",
    },
    counters: {
      countries: "Countries Connected",
      categories: "Product Categories",
      partners: "Strategic Partners",
      solutions: "Trade Solutions",
    },
    sections: {
      featuredExports: "Featured Export Commodities",
      featuredExportsSub: "Premium-grade products sourced from verified producers, ready for global shipment.",
      importCats: "Import Product Categories",
      importCatsSub: "Diversified imports for distributors, retailers and institutional buyers.",
      services: "Trade Services",
      servicesSub: "End-to-end trade solutions, from sourcing to last-mile distribution.",
      partners: "Trusted by Global Partners",
      cta: "Ready to Trade Globally?",
      ctaSub: "Submit your inquiry and our trade desk will respond within 24 hours.",
    },
    product: {
      origin: "Origin Country", grade: "Grade", moq: "Minimum Order",
      packaging: "Packaging", documents: "Documents Available",
      loadingPort: "Loading Port", monthlyCapacity: "Monthly Capacity",
      specifications: "Specifications", catalogue: "Catalogue PDF",
      bulkPrice: "Bulk Price Available Upon Inquiry",
      requestLatestQuote: "Request Latest Quote",
      shareOn: "Share / Follow",
      relatedProducts: "Related Products",
    },
    rfq: {
      title: "Request for Quotation",
      subtitle: "Tell us what you need. Our trade desk replies within 24 hours.",
      name: "Your Name", company: "Company", country: "Country",
      email: "Email Address", whatsapp: "WhatsApp Number",
      interest: "Product / Service Interest", quantity: "Estimated Quantity",
      destination: "Destination Country / Port", message: "Message",
      send: "Send Inquiry", success: "Thank you. We'll be in touch within 24 hours.",
    },
    footer: {
      tagline: "International trade, simplified.",
      offices: "Offices", quickLinks: "Quick Links", followUs: "Follow Us",
      rights: "All rights reserved.",
    },
    admin: {
      login: "Admin Login", loginGoogle: "Sign in with Google",
      loginNote: "Restricted to authorized administrators.",
      dashboard: "Dashboard", overview: "Overview",
      products: "Products", categories: "Categories", services: "Services",
      catalogues: "Catalogues", news: "News", inquiries: "Inquiries",
      team: "Team",
      catalogueRequests: "Catalogue Leads",
      settings: "Site Settings", logout: "Logout",
      autoTranslate: "Auto-translate to TR & ID",
      translating: "Translating...",
    },
  },
  tr: {
    nav: {
      home: "Ana Sayfa", about: "Hakkımızda", export: "İhracat Ürünleri",
      import: "İthalat Ürünleri", services: "Ticaret Hizmetleri",
      catalogue: "Katalog Merkezi", news: "Haberler", contact: "İletişim / Teklif",
      admin: "Yönetici",
    },
    common: {
      learnMore: "Daha Fazla", viewAll: "Tümünü Gör", explore: "Keşfet",
      requestQuote: "Teklif İste", contactUs: "İletişim", readMore: "Devamı",
      download: "İndir", inquireNow: "Hemen Sor", whatsappQuote: "WhatsApp ile Teklif",
      requestAccess: "Erişim İste", submit: "Gönder", cancel: "İptal",
      loading: "Yükleniyor...", noResults: "Sonuç bulunamadı.",
      backToList: "Listeye Dön", featured: "Öne Çıkan",
    },
    hero: {
      eyebrow: "Küresel Ticaret • Emtia • Ticaret Çözümleri",
      title: "Pazarları Birleştirir,",
      titleAccent: "Güveni Sağlar.",
      subtitle: "Endonezya, Türkiye, Singapur ve Güneydoğu Asya'yı küresel pazarlara bağlayan premium ithalat-ihracat ve emtia ticareti.",
      cta1: "Ürünleri Keşfet", cta2: "Teklif İste",
    },
    counters: {
      countries: "Bağlantılı Ülke", categories: "Ürün Kategorisi",
      partners: "Stratejik Ortak", solutions: "Ticaret Çözümü",
    },
    sections: {
      featuredExports: "Öne Çıkan İhracat Ürünleri",
      featuredExportsSub: "Doğrulanmış üreticilerden temin edilen premium kalite ürünler.",
      importCats: "İthalat Ürün Kategorileri",
      importCatsSub: "Distribütörler, perakendeciler ve kurumsal alıcılar için çeşitli ithalat.",
      services: "Ticaret Hizmetleri",
      servicesSub: "Tedarikten son teslimata kadar uçtan uca çözümler.",
      partners: "Küresel Ortakların Güvendiği",
      cta: "Küresel Ticarete Hazır mısınız?",
      ctaSub: "Talebinizi gönderin, ticaret masamız 24 saat içinde dönüş yapsın.",
    },
    product: {
      origin: "Menşe Ülke", grade: "Sınıf", moq: "Minimum Sipariş",
      packaging: "Paketleme", documents: "Mevcut Belgeler",
      loadingPort: "Yükleme Limanı", monthlyCapacity: "Aylık Kapasite",
      specifications: "Teknik Özellikler", catalogue: "Katalog PDF",
      bulkPrice: "Toplu Fiyat Talep Üzerine",
      requestLatestQuote: "Güncel Teklif İsteyin",
      shareOn: "Paylaş / Takip Et",
      relatedProducts: "İlgili Ürünler",
    },
    rfq: {
      title: "Teklif Talebi",
      subtitle: "İhtiyacınızı bildirin. 24 saat içinde dönüş yaparız.",
      name: "Ad Soyad", company: "Şirket", country: "Ülke",
      email: "E-posta", whatsapp: "WhatsApp",
      interest: "Ürün / Hizmet İlgisi", quantity: "Tahmini Miktar",
      destination: "Varış Ülkesi / Limanı", message: "Mesaj",
      send: "Talep Gönder", success: "Teşekkürler. 24 saat içinde dönüş yapacağız.",
    },
    footer: {
      tagline: "Uluslararası ticaret, basitleştirildi.",
      offices: "Ofisler", quickLinks: "Hızlı Linkler", followUs: "Takip Et",
      rights: "Tüm hakları saklıdır.",
    },
    admin: {
      login: "Yönetici Girişi", loginGoogle: "Google ile Giriş",
      loginNote: "Yalnızca yetkili yöneticiler.",
      dashboard: "Kontrol Paneli", overview: "Genel Bakış",
      products: "Ürünler", categories: "Kategoriler", services: "Hizmetler",
      catalogues: "Kataloglar", news: "Haberler", inquiries: "Talepler",
      team: "Ekip",
      catalogueRequests: "Katalog Talepleri",
      settings: "Site Ayarları", logout: "Çıkış",
      autoTranslate: "TR & ID'ye otomatik çevir",
      translating: "Çevriliyor...",
    },
  },
  id: {
    nav: {
      home: "Beranda", about: "Tentang Kami", export: "Komoditas Ekspor",
      import: "Produk Impor", services: "Layanan Perdagangan",
      catalogue: "Pusat Katalog", news: "Berita & Wawasan", contact: "Kontak / RFQ",
      admin: "Admin",
    },
    common: {
      learnMore: "Selengkapnya", viewAll: "Lihat Semua", explore: "Jelajahi",
      requestQuote: "Minta Penawaran", contactUs: "Hubungi Kami", readMore: "Baca Selengkapnya",
      download: "Unduh", inquireNow: "Tanya Sekarang", whatsappQuote: "Penawaran WhatsApp",
      requestAccess: "Minta Akses", submit: "Kirim", cancel: "Batal",
      loading: "Memuat...", noResults: "Tidak ada hasil.",
      backToList: "Kembali ke Daftar", featured: "Unggulan",
    },
    hero: {
      eyebrow: "Perdagangan Global • Komoditas • Solusi Dagang",
      title: "Menghubungkan Pasar,",
      titleAccent: "Memberikan Kepercayaan.",
      subtitle: "Impor-ekspor dan perdagangan komoditas premium yang menghubungkan Indonesia, Türkiye, Singapura, dan Asia Tenggara dengan pasar global.",
      cta1: "Jelajahi Komoditas", cta2: "Minta Penawaran",
    },
    counters: {
      countries: "Negara Terhubung", categories: "Kategori Produk",
      partners: "Mitra Strategis", solutions: "Solusi Perdagangan",
    },
    sections: {
      featuredExports: "Komoditas Ekspor Unggulan",
      featuredExportsSub: "Produk kualitas premium dari produsen terverifikasi, siap pengiriman global.",
      importCats: "Kategori Produk Impor",
      importCatsSub: "Impor terdiversifikasi untuk distributor, ritel, dan pembeli institusional.",
      services: "Layanan Perdagangan",
      servicesSub: "Solusi perdagangan menyeluruh, dari pengadaan hingga distribusi.",
      partners: "Dipercaya oleh Mitra Global",
      cta: "Siap Berdagang Global?",
      ctaSub: "Kirim permintaan Anda, tim kami akan merespons dalam 24 jam.",
    },
    product: {
      origin: "Negara Asal", grade: "Grade", moq: "Pesanan Minimum",
      packaging: "Pengemasan", documents: "Dokumen Tersedia",
      loadingPort: "Pelabuhan Muat", monthlyCapacity: "Kapasitas Bulanan",
      specifications: "Spesifikasi", catalogue: "Katalog PDF",
      bulkPrice: "Harga Grosir Berdasarkan Permintaan",
      requestLatestQuote: "Minta Penawaran Terkini",
      shareOn: "Bagikan / Ikuti",
      relatedProducts: "Produk Terkait",
    },
    rfq: {
      title: "Permintaan Penawaran",
      subtitle: "Beritahu kebutuhan Anda. Tim kami merespons dalam 24 jam.",
      name: "Nama", company: "Perusahaan", country: "Negara",
      email: "Email", whatsapp: "WhatsApp",
      interest: "Minat Produk / Layanan", quantity: "Perkiraan Kuantitas",
      destination: "Negara / Pelabuhan Tujuan", message: "Pesan",
      send: "Kirim Permintaan", success: "Terima kasih. Kami akan menghubungi dalam 24 jam.",
    },
    footer: {
      tagline: "Perdagangan internasional, disederhanakan.",
      offices: "Kantor", quickLinks: "Tautan Cepat", followUs: "Ikuti Kami",
      rights: "Hak cipta dilindungi.",
    },
    admin: {
      login: "Login Admin", loginGoogle: "Masuk dengan Google",
      loginNote: "Hanya untuk administrator resmi.",
      dashboard: "Dasbor", overview: "Ringkasan",
      products: "Produk", categories: "Kategori", services: "Layanan",
      catalogues: "Katalog", news: "Berita", inquiries: "Permintaan",
      team: "Tim",
      catalogueRequests: "Permintaan Katalog",
      settings: "Pengaturan Situs", logout: "Keluar",
      autoTranslate: "Auto-translate ke TR & ID",
      translating: "Menerjemahkan...",
    },
  },
};

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("nakia_lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("nakia_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const keys = path.split(".");
    let cur = STRINGS[lang] || STRINGS.en;
    for (const k of keys) {
      cur = cur?.[k];
      if (cur === undefined) {
        cur = path; break;
      }
    }
    return cur;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
};
